import { ReactElement, useEffect } from 'react'

import { Layout } from 'antd'
import classNames from 'classnames'

import { LoadingIndicator } from 'components/LoadingIndicator'
import { bootstrapApp } from 'features/App/appService'
import { getOrganizationTheme } from 'helpers/organizationTheme'
import { GlobalNotification, Organization, UserPermission } from 'types'

import PageRoutes from '../../routing/PageRoutes'

import { FloatingChatMount } from './FloatingChatMount'
import MfaCheck from './MfaCheck'
import { SideMenu } from './SideMenu'
import * as styles from './styles.scss'

export interface AppLayoutProps {
    // hasRecentIntegration: boolean
    hasNoIntegrations: boolean
    currentOrganization?: Organization
    featurePermissions: UserPermission[]
    globalNotification?: GlobalNotification | null
    isSidebarCollapsed: boolean
    mounting: boolean
    toggleSidebarCollapsed: () => void
}

function AppLayout({
    hasNoIntegrations,
    featurePermissions,
    currentOrganization,
    isSidebarCollapsed,
    mounting,
    toggleSidebarCollapsed,
}: AppLayoutProps): ReactElement {
    useEffect(() => {
        bootstrapApp()
    }, [])

    if (mounting) {
        return (
            <LoadingIndicator
                size="small"
                style={{ position: 'relative', minHeight: '300px' }}
            />
        )
    }

    const theme = getOrganizationTheme(currentOrganization)

    return (
        <Layout>
            <Layout.Sider
                width={208}
                collapsed={isSidebarCollapsed}
                className={classNames(styles.sider, {
                    [theme?.primary_color ?? '']: Boolean(theme?.primary_color),
                })}
            >
                <SideMenu
                    currentOrganization={currentOrganization}
                    isSidebarCollapsed={isSidebarCollapsed}
                    featurePermissions={featurePermissions}
                    hasNoIntegrations={hasNoIntegrations}
                    toggleSidebarCollapsed={toggleSidebarCollapsed}
                />
            </Layout.Sider>

            <Layout
                className={classNames([styles['content-layout']], {
                    [styles.collapsed]: isSidebarCollapsed,
                })}
            >
                <Layout.Content className={styles.content}>
                    <MfaCheck />
                    <PageRoutes />
                </Layout.Content>
            </Layout>

            <FloatingChatMount />
        </Layout>
    )
}

export default AppLayout
